<template>
  <user-management-component/>
</template>

<script>
import UserManagementComponent from '@/spa/components/board/user-management/BoardUserManagement';

export default {
  name: 'UserManagementPage',
  components: {
    UserManagementComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/operation/UserManagementPage.vue